/**
 * OTP Callback Registry
 * 
 * Stores callback functions for OTP confirmations since functions
 * cannot be serialized to localStorage with notifications
 */

class OTPCallbackRegistry {
  constructor() {
    this.callbacks = new Map();
  }

  register(otpCode, callback, additionalData = {}) {
    console.log('🔐 Registering OTP callback:', otpCode, additionalData);
    console.log('🔐 Callback function type:', typeof callback);
    this.callbacks.set(otpCode, {
      callback,
      ...additionalData,
      registeredAt: Date.now()
    });
    
    // Log current registry state after registration
    console.log('🔐 Registry after registration:', this.getAllCallbacks());
    
    // Auto-cleanup after 10 minutes
    setTimeout(() => {
      console.log('🔐 Auto-cleaning up OTP callback:', otpCode);
      this.callbacks.delete(otpCode);
    }, 600000);
  }

  get(otpCode) {
    const result = this.callbacks.get(otpCode);
    console.log('🔐 Getting OTP callback:', otpCode, result ? 'found' : 'not found');
    return result;
  }

  execute(otpCode) {
    const entry = this.callbacks.get(otpCode);
    if (entry && entry.callback) {
      return entry.callback();
    }
    return Promise.resolve();
  }

  remove(otpCode) {
    console.log('🔐 Removing OTP callback:', otpCode);
    this.callbacks.delete(otpCode);
  }

  clear() {
    this.callbacks.clear();
  }

  // Debug method to see all registered callbacks
  getAllCallbacks() {
    const result = {};
    for (const [otp, data] of this.callbacks.entries()) {
      result[otp] = {
        ...data,
        callback: data.callback ? '[Function]' : 'undefined'
      };
    }
    return result;
  }
}

const otpCallbackRegistry = new OTPCallbackRegistry();

export default otpCallbackRegistry;

